webpackJsonp([20680281995392],{

/***/ 355:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulBlog":{"title":"Dinner Dance","slug":"dinner-dance","metaDescription":"Dinner Dance","body":{"childMarkdownRemark":{"html":"<p>A Special Dinner Dance tkes place in the Gateway Hotel on 100th AUgust at 7pm. THis is to celebrte 150 years of Killasser Church<img src=\"//images.ctfassets.net/6rnd0h65xc7e/4ueIy6zrva0IEE2y2oW4ue/e8a38d29fc26a2ceb5357bbec880a131/dinner_table_feast.jpg\" alt=\"curry feast\"></p>"}},"featuredImage":null}},"pathContext":{"slug":"dinner-dance"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-dinner-dance-d15730ab07e77d9eac41.js